import { render, staticRenderFns } from "./app-mian-footer.vue?vue&type=template&id=33d34081&scoped=true"
import script from "./app-mian-footer.vue?vue&type=script&lang=js"
export * from "./app-mian-footer.vue?vue&type=script&lang=js"
import style0 from "./app-mian-footer.vue?vue&type=style&index=0&id=33d34081&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d34081",
  null
  
)

export default component.exports